import type { GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { InternalNewsListPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof InternalNewsListPresentation>;
type Args = {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200;
};
type IConvertToInternalNewsListProps = (args: Args) => {
  items: PresentationProps['items'];
  /** データ 0 件のとき true（Empty コンポーネントを表示する条件） */
  isEmpty: boolean;
};

/**
 * API レスポンスを社内報一覧 UI 型に変換する。
 * ステータスは API レスポンスの is_published を直接利用する。
 */
export const convertToInternalNewsListProps: IConvertToInternalNewsListProps = ({ data }) => {
  const items = data.client_newsletters.map(newsletter => {
    const publishAtMs = newsletter.publish_at * 1000;
    const published = newsletter.is_published;

    return {
      id: newsletter.id,
      title: newsletter.title,
      publishAt: formatDate({
        date: new Date(publishAtMs),
        formatType: 'yyyy/M/d H:mm',
      }),
      status: published ? ('published' as const) : ('scheduled' as const),
      statusLabel: published ? '公開済み' : '公開予定',
      badgeStatus: published ? ('success' as const) : ('info' as const),
      viewRate: `${newsletter.read_rate_at_publication}%`,
    };
  });

  const isEmpty = items.length === 0;

  return { items, isEmpty };
};
